var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-2" },
    [
      _c("base-dialog", {
        attrs: {
          okFn: function async() {
            _vm.defaultLoginCallback(_vm.loginInfo)
          },
          content: _vm.loginEdgeCaseDialog.content
        },
        model: {
          value: _vm.loginEdgeCaseDialog.visible,
          callback: function($$v) {
            _vm.$set(_vm.loginEdgeCaseDialog, "visible", $$v)
          },
          expression: "loginEdgeCaseDialog.visible"
        }
      }),
      _vm._v(" "),
      _c(
        "base-dialog",
        {
          attrs: {
            keepOpened: "",
            okFn: function async() {
              _vm.acceptTerms()
            },
            cancelFn: function() {
              _vm.denyTerms()
            }
          },
          model: {
            value: _vm.termsAndConditionsModalVisible,
            callback: function($$v) {
              _vm.termsAndConditionsModalVisible = $$v
            },
            expression: "termsAndConditionsModalVisible"
          }
        },
        [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.$t("login.terms-and-conditions")) +
              "\n\t\t\t"
          ),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "terms-ctn" },
            [
              _vm.userRoleIsPatient
                ? _c("TermsAndConditionsPatient")
                : _c("TermsAndConditionsProfessional")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              attrs: { state: _vm.termsAndConditionsAccepted },
              model: {
                value: _vm.termsAndConditionsAccepted,
                callback: function($$v) {
                  _vm.termsAndConditionsAccepted = $$v
                },
                expression: "termsAndConditionsAccepted"
              }
            },
            [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("login.terms-and-conditions-accept")) +
                  "\n\t\t\t"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-dialog",
        {
          attrs: {
            keepOpened: "",
            okFn: function async() {
              _vm.acceptPrivacyPolicy()
            },
            cancelFn: function() {
              _vm.denyPrivacyPolicy()
            }
          },
          model: {
            value: _vm.privacyPolicyModalVisible,
            callback: function($$v) {
              _vm.privacyPolicyModalVisible = $$v
            },
            expression: "privacyPolicyModalVisible"
          }
        },
        [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.$t("login.privacy-policy")) + "\n\t\t\t"
          ),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "terms-ctn" },
            [
              _vm.userRoleIsPatient
                ? _c("PrivacyPolicy")
                : _c("PrivacyPolicyProfessional")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              attrs: { state: _vm.privacyPolicyAccepted },
              model: {
                value: _vm.privacyPolicyAccepted,
                callback: function($$v) {
                  _vm.privacyPolicyAccepted = $$v
                },
                expression: "privacyPolicyAccepted"
              }
            },
            [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("login.privacy-policy-accept")) +
                  "\n\t\t\t"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.titleVisible ? _c("h3", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form",
        {
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.login.apply(null, arguments)
            }
          }
        },
        [
          _vm.form.state.submitted && _vm.form.state.unauthorized
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _vm._v(_vm._s(_vm.submitError))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.checkCredentials
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _vm._v(
                  _vm._s(
                    !_vm.mfaVisible
                      ? _vm.$t("invalid-credentials")
                      : _vm.$t("invalid-2facode")
                  )
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.state.submitted && _vm.form.state.errors
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.accountError || _vm.$t("login.server-error")
                    )
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.mfaVisible
            ? _c(
                "b-form-group",
                [
                  _c("base-input", {
                    attrs: {
                      placeholder: _vm.$t("login.email"),
                      state: _vm.emailValidation,
                      errorMsg: _vm.$t("login.errors.email"),
                      autocomplete: "disabled"
                    },
                    model: {
                      value: _vm.form.email,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "base-input",
                    {
                      attrs: {
                        placeholder: _vm.$t("login.password"),
                        type: _vm.showPassword ? "text" : "password",
                        state: _vm.passwordValidation,
                        errorMsg: _vm.$t("login.errors.password"),
                        autocomplete: "disabled"
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password"
                      }
                    },
                    [
                      _c("template", { slot: "append" }, [
                        _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                _vm.showPassword = !_vm.showPassword
                              }
                            }
                          },
                          [
                            _c(
                              "i",
                              [
                                !_vm.showPassword ? _c("b-icon-eye") : _vm._e(),
                                _vm.showPassword
                                  ? _c("b-icon-eye-slash")
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            : _c(
                "b-form-group",
                [
                  _c("base-input", {
                    attrs: {
                      placeholder: _vm.$t("login.twoFACode-ph"),
                      label: _vm.$t("login.twoFACode")
                    },
                    model: {
                      value: _vm.form.mfaCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "mfaCode", $$v)
                      },
                      expression: "form.mfaCode"
                    }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticStyle: { width: "100%" },
              attrs: {
                type: "submit",
                variant: "primary",
                disabled: _vm.$store.state.loading
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("login.sign-in")) + "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _vm.inOpenlegal()
            ? _c(
                "b-button",
                {
                  staticClass: "mt-4",
                  staticStyle: { width: "100%" },
                  attrs: { variant: "outline-primary" },
                  on: { click: _vm.$helpers.gotoACAUrl }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("login.aca-sign-in")) +
                      "\n      "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "router-link",
            {
              attrs: { to: "/cuenta/peticion-actualizar-contrasena", tag: "a" }
            },
            [_vm._v(_vm._s(_vm.$t("login.forget-password")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c7aad26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c7aad26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/LoginForm.vue
// module id = 1627
// module chunks = 116